import React from "react";
import styled, { createGlobalStyle } from "styled-components"
import { EColor as EColor } from "../../styleConstants";
import { breakPoint } from "../styleUtils";

//Resets style inherited from global css sheet for some elements
const StyleReset = createGlobalStyle`
    @import url('https://fonts.googleapis.com/css?family=Roboto:400,500,700,900&display=swap');

    @font-face {
        font-family: "readly-glyphs";
        src: url("https://dnjpbxg2wcpr8.cloudfront.net/web/fonts/Readly-Glyphs.ttf");
        font-weight: 600;
        font-display: block;
    }    


    /* Black header */
    #wrapper.dark .navbar {
        background: black;
    }

    /* Black footer */
    #footer.dark {
        background: black;
    }
`
type WrapperProps = {
    background: EColor
}

const Wrapper = styled.div<WrapperProps>`
    background: ${props => props.background ? props.background : EColor.RussianGradient };
    //background-attachment: ${props => props.background ? "inherit" : "fixed" };
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    width: 100%;
    max-width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    min-height: 100%;
    

    * a:hover, * a:active {
        text-decoration: none;
        color: white;
    }
`

export default function PageWrapper ({
    children,
    background,
}: {
    children: JSX.Element|JSX.Element[]
    background? : EColor
}) {
    return (
        <Wrapper background={background}>
            <StyleReset />
            {children}
        </Wrapper>
    )
}